import { Action } from '@interstate/components/Action';
import { Alert } from '@interstate/components/Alert';
import { Grid } from '@interstate/components/Grid';
import { Typography } from '@interstate/components/Typography';

import {
    AUTO_SELECTED_LENDER_PROGRAM_BANNER_BODY,
    AUTO_SELECTED_LENDER_PROGRAM_BANNER_LINK,
    AUTO_SELECTED_LENDER_PROGRAM_BANNER_SUFFIX
} from '../constants';
import { useAutoSelectedLenderProgramBanner } from './useAutoSelectedLenderProgramBanner';

export const AutoSelectedLenderProgramBanner = () => {
    const { isAutoSelected, openProgramsAndIncentives } = useAutoSelectedLenderProgramBanner();

    if (!isAutoSelected) {
        return null;
    }

    return (
        <Grid xs={12} padding="0" marginBottom="1rem">
            <Alert type="info" role="banner" data-testid="auto-selected-lender-program-banner">
                <Typography variant="label-md" tag="span">
                    {AUTO_SELECTED_LENDER_PROGRAM_BANNER_BODY}
                </Typography>
                <Action size="sm" onClick={openProgramsAndIncentives} data-testid="auto-selected-lender-program-banner-cta">
                    {AUTO_SELECTED_LENDER_PROGRAM_BANNER_LINK}
                </Action>
                <Typography variant="label-md" tag="span">
                    {AUTO_SELECTED_LENDER_PROGRAM_BANNER_SUFFIX}
                </Typography>
            </Alert>
        </Grid>
    );
};
